import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const bookingsState = (state: RootState): RootState['bookings'] => state.bookings;
export const resourceState = (state: RootState): RootState['resource'] => state.resource;

export const selectBookingRequest = createSelector(bookingsState, bookings => bookings.createBookingRequest);
export const selectBookingsError = createSelector(bookingsState, bookings => bookings.error);
